import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {classToClass} from "class-transformer";
import {SelectItem} from "primeng/api";

import {DialogStyle40} from "@app/shared/classes/common";
import {CommonDocRepoService} from "@app/shared/services/common-doc-repo.service";
import {DocFile} from "@app/shared/classes/doc-file";
import {DocumentType} from "@app/shared/enums/document-type.enum";
import {Format} from "@app/shared/enums/format.enum";
import {JurisdictionData, ParameterValueMap, TaxInfo, TaxItemInfo} from "@app/shared/classes/tax-information";
import {FilingStatus2020, FilingStatusNon2020, W4Params} from "@app/shared/tax-information/tax-information";
import {CommonTransformationService, ParamListResponse, PayrollService} from "@app/shared";

@Component({
  selector: 'app-tax-information',
  templateUrl: './tax-information.component.html',
  styleUrls: ['./tax-information.component.css']
})
export class TaxInformationComponent implements OnInit {

  DialogStyle40 = DialogStyle40;
  // Input and Output value to tax component
  private _jurisdictionTaxData: any;

  @Input()
  set jurisdictionTaxData(value: any) {
    this._jurisdictionTaxData = value;
    this.processJurisdictionTaxData();
    this.setFormValue();
  }

  @Input() userid?: number;
  @Input() uiName: string; // profile , netPay
  @Output() onChangeTaxInfo = new EventEmitter<ParamListResponse>();
  @Output() onCompleteTaxInfo = new EventEmitter<boolean>();


  // standard format and validation
  Format: typeof Format = Format;
  DocumentType: typeof DocumentType = DocumentType;


  // main properties
  newTax: boolean; // check if tax value is new or existing
  taxInfo: TaxInfo[]; // values of tax table
  jurisdictionData: JurisdictionData[]; // jurisdiction data
  parameterValueMap: ParameterValueMap; // map values to all parameters
  formData: any; // form data object which used to return all value of local, state and fedral tax information
  fileUploadLabel: string; // label for upload file
  locationCode: string; // show location code
  parameterNameMap: any; // parameter name to map with value
  taxItemInfo: TaxItemInfo[]; // map tax item information
  skipSavingW4Info: boolean = false;

  // fedral tax
  newFederalFileName: string; // fedral file name
  federalW4Id: number; // fedral w4 id
  federalFormData: any = {}; // fedral form data
  federalFields: string[]; // fields of fedral
  questionList: JurisdictionData[]; // fedral form question list
  fedralInfotableColumns: any[] = [];  // fedral table columns
  newFederalFileError: boolean; // flag to show error in fedral file
  federalTaxDialog: boolean; // show or hide fedral tax dialog
  show2020TaxFields: boolean;
  taxFields2020ToSkip: Set<W4Params> = new Set<W4Params>();
  non2020TaxFieldsToSkip: Set<W4Params> = new Set<W4Params>();
  filingStatusOptions: SelectItem[];
  filingStatus2020: SelectItem[];
  filingStatusNon2020: SelectItem[];


  // state tax
  stateFormData: any = {}; // state form data
  newStateFileName: string; // state file name which is uploaded
  stateW4Id: number; // state w4 id
  stateFields: string[]; // state form field list
  stateQuestionList: JurisdictionData[]; // state form questio  list
  newStateFileError: boolean; // flag to show error in state file
  stateTaxDialog: boolean; // show or hide state tax dialog

  // local tax
  localFormData: any = {}; // local form data
  localTaxForm: JurisdictionData[]; // form field of local tax
  localFields: string[]; // local fields
  localTaxDialog: boolean; // show local tax dialog
  w4Params: typeof W4Params = W4Params;


  constructor(private docRepoService: CommonDocRepoService, private payrollService: PayrollService, private transform: CommonTransformationService) {
  }

  ngOnInit() {

    /**
     * @desc: fedral table colums
     */
    if (this.uiName == 'profile' || this.uiName == 'payee') {
      this.fedralInfotableColumns = [
        {field: 'status', header: 'Complete'},
        {field: 'taxInformation', header: 'Tax Information'},
        {field: 'file', header: 'File Name'},
        {field: 'actions', header: 'Action'},
      ];
    } else {
      this.fedralInfotableColumns = [
        {field: 'status', header: 'Complete'},
        {field: 'taxInformation', header: 'Tax Information'},
        {field: 'actions', header: 'Action'},
      ];
    }
    this.taxFields2020ToSkip = this.payrollService.get2020TaxFields();
    this.non2020TaxFieldsToSkip = this.payrollService.getNon2020TaxFieldsToSkip();
    this.filingStatus2020 = this.transform.convertEnumToDropDown(FilingStatus2020, false);
    this.filingStatusNon2020 = this.transform.convertEnumToDropDown(FilingStatusNon2020, false);
    if (this._jurisdictionTaxData && this._jurisdictionTaxData.parameterNameMap) {
      this.processJurisdictionTaxData();
    }

    this.setFormValue();
    this.validateTaxInformation(this.formData);
  }

  /**
   * @desc: process jurisdiction Tax info
   */
  processJurisdictionTaxData() {

    console.log("this.jurisdictionTaxData ->", this._jurisdictionTaxData);
    let data = this._jurisdictionTaxData;

    if (data.payrollPayeeW4Form && data.payrollPayeeW4Form.stateW4Id) {
      this.stateW4Id = data.payrollPayeeW4Form.stateW4Id;
      this.newStateFileName = data.payrollPayeeW4Form.stateW4.fileName;
    }
    if (data.payrollPayeeW4Form && data.payrollPayeeW4Form.federalW4Id) {
      this.federalW4Id = data.payrollPayeeW4Form.federalW4Id;
      this.newFederalFileName = data.payrollPayeeW4Form.federalW4.fileName;
    }

    this.parameterNameMap = data.parameterNameMap;
    this.parameterValueMap = data.parameterValueMap;
    this.taxItemInfo = data.taxItemInfo;
    this.jurisdictionData = data.jurisdictionData;
    this.locationCode = data.locationCode;
    // create seprate array from pareameter name map
    for (var prop in data.parameterNameMap) {
      if (prop.startsWith("00")) {
        this.federalFields = data.parameterNameMap[prop];
      } else if (prop.includes("SIT")) {
        this.stateFields = data.parameterNameMap[prop];
      } else if (!prop.includes("SIT") && !prop.includes("ER") && !prop.startsWith("00")) {
        this.localFields = data.parameterNameMap[prop];
      }

    }

    this.generateDynamicForm();

  }

  validateFederalTaxInformation(data: any) {
    let validationFlag = true;
    if (this._jurisdictionTaxData.parameterValueMap.FEDERAL) {
      for (var prop in this._jurisdictionTaxData.parameterValueMap.FEDERAL) {
        if (data[prop] == null) {
          if (this.show2020TaxFields && !this.non2020TaxFieldsToSkip.has(<W4Params>prop)) {
            validationFlag = false;
            console.log("saving w4 info is skipped due to missing federal param", prop);
          } else if (!this.show2020TaxFields && !this.taxFields2020ToSkip.has(<W4Params>prop)) {
            validationFlag = false;
            console.log("saving w4 info is skipped due to missing federal param", prop);
          }
        }
      }
    }
    return validationFlag;
  }

  validateStateTaxInformation(data: any) {
    let validationFlag = true;
    if (this._jurisdictionTaxData.parameterValueMap.STATE) {
      for (var prop in this._jurisdictionTaxData.parameterValueMap.STATE) {
        if (data[prop] == null) {
          validationFlag = false;
          console.log("skip saving is set to true due to missing state param", prop);
        }
      }
    }
    return validationFlag;
  }

  validateLocalTaxInformation(data: any) {
    let validationFlag = true;
    if (this._jurisdictionTaxData.parameterValueMap.EMPLOYER && this.localFields) {
      for (var prop in this._jurisdictionTaxData.parameterValueMap.EMPLOYER) {
        if (data[prop] == null) {
          validationFlag = false;
          console.log("saving w4 info is skipped due to missing local param", prop);
        }
      }
    }
    return validationFlag;
  }


  validateTaxInformation(data: any) {
    let stateValidation = this.validateStateTaxInformation(data.stateFormData);
    let federalValidation = this.validateFederalTaxInformation(data.fedralFormData);
    let localValidation = this.validateLocalTaxInformation(data.localFormData);

    if (stateValidation && federalValidation && localValidation) {
      this.skipSavingW4Info = false;
    } else {
      this.skipSavingW4Info = true;
    }
  }

  /**
   * @desc: generate dynamic form from jurisdiction Tax info
   */
  generateDynamicForm() {

    this.taxInfo = [];
    this.questionList = [];
    this.stateQuestionList = [];
    this.localTaxForm = [];
    // generate fedral from field
    if (this.federalFields) {
      this.generateFederalForm();
    }
    // generate state from field
    if (this.stateFields) {
      this.generateStateForm();
    }
    // generate local from field
    if (this.localFields) {
      this.generateLocalForm();
    }

  }

  /**
   * @desc: open tax form fot edit
   */
  editTaxInformation(data) {
    this.newTax = false;
    if (data.taxInformation == 'Federal Income Tax') {
      this.federalTaxDialog = true;
    } else if (data.taxInformation == 'State Income Tax') {
      this.stateTaxDialog = true;
    } else {
      this.localTaxDialog = true;
    }
  }

  /**
   * @desc: Set value in formData object to return updated value in parent components
   */
  setFormValue() {
    this.formData = {
      localFormData: this.localFormData,
      stateFormData: this.stateFormData,
      fedralFormData: this.federalFormData
    };
  }

  /**
   * @desc: add fedral Tax and set status as complete
   */
  addFederalTax() {
    this.taxInfo[0].status = true;
    this.federalTaxDialog = false;
    this.setValueMap(this.formData);
    this.validateTaxInformation(this.formData);
    if (!this.skipSavingW4Info) {
      this.onCompleteTaxInfo.emit(true);
    }

    //this.onChangeTaxInfo.emit(this.formData);
  }

  /**
   * @desc: add local Tax and set status as complete
   */
  addLocalTax() {
    this.taxInfo[2].status = true;
    this.localTaxDialog = false;
    this.setValueMap(this.formData);
    this.validateTaxInformation(this.formData);
    if (!this.skipSavingW4Info) {
      this.onCompleteTaxInfo.emit(true);
    }
    //this.onChangeTaxInfo.emit(this.formData);
  }

  /**
   * @desc: add state Tax and set status as complete
   */
  addStateTax() {
    this.taxInfo[1].status = true;
    this.stateTaxDialog = false;
    this.setValueMap(this.formData);
    this.validateTaxInformation(this.formData);
    console.log("W4 params are about to be saved", this.skipSavingW4Info);
    if (!this.skipSavingW4Info) {
      this.onCompleteTaxInfo.emit(true);
    }
    //this.onChangeTaxInfo.emit(this.formData);
  }

  /**
   * @desc process selected quality of life file data
   */
  handleLoadedFederalFile(docFile: DocFile) {
    let payrollPayeeW4Form = this._jurisdictionTaxData.payrollPayeeW4Form ? this._jurisdictionTaxData.payrollPayeeW4Form : {};
    //let payrollPayeeW4Form = this.jurisdictionTaxData.payrollPayeeW4Form;
    if (docFile.fileName == this.newStateFileName) {
      this.newFederalFileError = true;
      this.newFederalFileName = null;
      return false;
    } else {
      this.newFederalFileError = false;
    }
    if (docFile && docFile.data) {
      if (payrollPayeeW4Form.federalW4 && payrollPayeeW4Form.federalW4.id) {
        payrollPayeeW4Form.federalW4.data = docFile.data;
        payrollPayeeW4Form.federalW4.mimeType = docFile.mimeType;
        payrollPayeeW4Form.federalW4.fileName = docFile.fileName;
      } else {
        payrollPayeeW4Form.federalW4 = docFile;
      }
      this.newFederalFileName = docFile.fileName;
      this.federalFormData.docFile = payrollPayeeW4Form.federalW4;
    } else {
      console.error("selected file is null or empty");
    }
  }

  /**
   * @desc process selected quality of life file data
   * @param docFile
   */
  handleLoadedStateFile(docFile: DocFile) {
    let payrollPayeeW4Form = this._jurisdictionTaxData.payrollPayeeW4Form ? this._jurisdictionTaxData.payrollPayeeW4Form : {};
    //let payrollPayeeW4Form = this.jurisdictionTaxData.payrollPayeeW4Form;
    console.log("payrollPayeeW4Form-->", payrollPayeeW4Form);
    if (docFile.fileName == this.newFederalFileName) {
      this.newStateFileError = true;
      this.newStateFileName = null;
      return false;
    } else {
      this.newStateFileError = false;
    }
    if (docFile && docFile.data) {
      if (payrollPayeeW4Form.stateW4 && payrollPayeeW4Form.stateW4.id) {
        payrollPayeeW4Form.stateW4.data = docFile.data;
        payrollPayeeW4Form.stateW4.mimeType = docFile.mimeType;
        payrollPayeeW4Form.stateW4.fileName = docFile.fileName;
      } else {
        payrollPayeeW4Form.stateW4 = docFile;
      }
      this.newStateFileName = docFile.fileName;
      this.stateFormData.docFile = payrollPayeeW4Form.stateW4;
    } else {
      console.error("selected file is null or empty");
    }
  }

  /**
   * @desc download file by id
   * @param data
   */
  onClickDownload(fileId: number) {
    this.docRepoService.getFileByIdThenSave(fileId);
  }

  /**
   * @desc generate fedral from data from federal array
   */
  generateFederalForm() {
    for (let i = 0; i < this.federalFields.length; i++) {
      for (let j = 0; j < this.jurisdictionData.length; j++) {
        if (this.federalFields[i] == this.jurisdictionData[j].parameterName && this.jurisdictionData[j].uniqueTaxID.startsWith("00")) {
          if (this.jurisdictionData[j].regexType == "PickList") {
            let options = [];
            if (this.jurisdictionData[j].listValues) {
              let valueString = this.jurisdictionData[j].listValues;
              let valueArray = valueString.split(",");
              for (let a = 0; a < valueArray.length; a++) {
                let val = valueArray[a].split("=");
                options.push({label: val[1].trim(), value: val[0].trim()});
              }
            } else {
              options.push({label: 'TRUE', value: "true"});
              options.push({label: 'FALSE', value: "false"});
            }
            this.jurisdictionData[j].options = options;

          }
          this.questionList.push(this.jurisdictionData[j]);
          this.federalFormData[this.jurisdictionData[j].parameterName] = this.parameterValueMap.FEDERAL[this.federalFields[i]];
          // let index = this.dueDatesToEdit.findIndex(item => item.date == dueDate);
          // if(this.questionList.find())
          this.questionList.sort((a, b) => a.parameterName.localeCompare(b.parameterName));
          if (this.jurisdictionData[j].parameterName == W4Params.FilingStatus) {
            this.setFilingStatusOption(JSON.parse(this.federalFormData[W4Params.W42020]));
          }
          console.log(this.federalFormData[this.jurisdictionData[j].parameterName]);
          console.log(this.questionList);
          break;
        }
      }
    }
    this.show2020TaxFields = JSON.parse(this.federalFormData[W4Params.W42020]);
    console.log("form data before validating ->", this.formData);
    let federalValidation: boolean = this.validateFederalTaxInformation(this.federalFormData);
    this.taxInfo.push({status: federalValidation, taxInformation: 'Federal Income Tax'});
  }

  setFilingStatusOption(w42020: boolean) {
    if (w42020) {
      this.filingStatusOptions = this.filingStatus2020;
    } else {
      this.filingStatusOptions = this.filingStatusNon2020;
    }
  }

  /**
   * @desc generate state from data from state array
   */
  generateStateForm() {
    for (let i = 0; i < this.stateFields.length; i++) {
      for (let j = 0; j < this.jurisdictionData.length; j++) {
        if (this.stateFields[i] == this.jurisdictionData[j].parameterName && this.jurisdictionData[j].uniqueTaxID.includes("SIT")) {
          if (this.jurisdictionData[j].regexType == "PickList") {
            let options = [];
            if (this.jurisdictionData[j].listValues) {
              let valueString = this.jurisdictionData[j].listValues;
              let valueArray = valueString.split(",");
              for (let a = 0; a < valueArray.length; a++) {
                let val = valueArray[a].split("=");
                options.push({label: val[1].trim(), value: val[0].trim()});
              }
            } else {
              options.push({label: 'TRUE', value: true});
              options.push({label: 'FALSE', value: false});
            }
            this.jurisdictionData[j].options = options;

          }
          this.stateFormData[this.jurisdictionData[j].parameterName] = this.parameterValueMap.STATE[this.stateFields[i]];

          this.stateQuestionList.push(this.jurisdictionData[j]);
          console.log(this.stateQuestionList);
          break;
        }

      }
    }
    let stateValidation: boolean = this.validateStateTaxInformation(this.stateFormData);
    this.taxInfo.push({status: stateValidation, taxInformation: 'State Income Tax'});
  }

  /**
   * @desc generate local from data from local array
   */
  generateLocalForm() {
    for (let i = 0; i < this.localFields.length; i++) {
      for (let j = 0; j < this.jurisdictionData.length; j++) {
        if (this.localFields[i] == this.jurisdictionData[j].parameterName && !this.jurisdictionData[j].uniqueTaxID.includes("SIT") && !this.jurisdictionData[j].uniqueTaxID.includes("ER") && !this.jurisdictionData[j].uniqueTaxID.startsWith("00")) {
          if (this.jurisdictionData[j].regexType == "PickList") {
            let options = [];
            if (this.jurisdictionData[j].listValues) {
              let valueString = this.jurisdictionData[j].listValues;
              let valueArray = valueString.split(",");
              for (let a = 0; a < valueArray.length; a++) {
                let val = valueArray[a].split("=");
                options.push({label: val[1].trim(), value: val[0].trim()});
              }
            } else {
              options.push({label: 'TRUE', value: true});
              options.push({label: 'FALSE', value: false});
            }
            this.jurisdictionData[j].options = options;
          }
          this.localTaxForm.push(this.jurisdictionData[j]);
          console.log(this.localTaxForm);
          break;
        }

      }
    }
    let localValidation: boolean = this.validateLocalTaxInformation(this.localFormData);
    this.taxInfo.push({status: localValidation, taxInformation: 'Local Tax'});
  }

  handle2020W4(chosenValue: string) {
    if (JSON.parse(chosenValue)) {
      this.federalFormData[W4Params.TotalAllowances] = null;
      this.filingStatusOptions = classToClass(this.filingStatus2020);
      this.show2020TaxFields = true;
    } else {
      this.federalFormData[W4Params.Deductions] = null;
      this.federalFormData[W4Params.OtherIncome] = null;
      this.federalFormData[W4Params.DependentsAmt] = null;
      this.filingStatusOptions = classToClass(this.filingStatusNon2020);
      this.show2020TaxFields = false;
    }
  }

  setValueMap(data: any) {
    if (this._jurisdictionTaxData.parameterValueMap.STATE) {
      for (var prop in this._jurisdictionTaxData.parameterValueMap.STATE) {
        if (data.stateFormData[prop] != null) {
          this._jurisdictionTaxData.parameterValueMap.STATE[prop] = data.stateFormData[prop];
        }
      }
    }

    if (this._jurisdictionTaxData.parameterValueMap.FEDERAL) {
      for (var prop in this._jurisdictionTaxData.parameterValueMap.FEDERAL) {
        if (data.fedralFormData[prop] != null) {
          this._jurisdictionTaxData.parameterValueMap.FEDERAL[prop] = data.fedralFormData[prop];
        }
      }
    }

    if (this._jurisdictionTaxData.parameterValueMap.EMPLOYER && this.localFields) {
      for (var prop in this._jurisdictionTaxData.parameterValueMap.EMPLOYER) {
        if (data.localFormData[prop] != null) {
          this._jurisdictionTaxData.parameterValueMap.EMPLOYER[prop] = data.localFormData[prop];
        }

      }
    }
    if (!this._jurisdictionTaxData.payrollPayeeW4Form) {
      this._jurisdictionTaxData.payrollPayeeW4Form = {};
    }
    let year = (new Date()).getFullYear();

    // year match
    if (data.fedralFormData.docFile) {
      this._jurisdictionTaxData.payrollPayeeW4Form.federalW4 = data.fedralFormData.docFile;
      if (!this._jurisdictionTaxData.payrollPayeeW4Form.federalW4.ownerId) {
        this._jurisdictionTaxData.payrollPayeeW4Form.federalW4.ownerId = this.userid;
      }
      //TODO- MANASA TO REVIEW WITH JIN
      if (this._jurisdictionTaxData.payrollPayeeW4Form.federalW4) {
        this._jurisdictionTaxData.payrollPayeeW4Form.federalW4.id = this._jurisdictionTaxData.payrollPayeeW4Form.federalW4Id;
      } else {
        this._jurisdictionTaxData.payrollPayeeW4Form.federalW4Id = null;
      }
    } else {
      if (this._jurisdictionTaxData.payrollPayeeW4Form) {
        if (!this._jurisdictionTaxData.payrollPayeeW4Form.federalW4) {
          this._jurisdictionTaxData.payrollPayeeW4Form.federalW4Id = null;
        }
      }
    }
    if (data.stateFormData.docFile) {
      this._jurisdictionTaxData.payrollPayeeW4Form.stateW4 = data.stateFormData.docFile;
      if (!this._jurisdictionTaxData.payrollPayeeW4Form.stateW4.ownerId) {
        this._jurisdictionTaxData.payrollPayeeW4Form.stateW4.ownerId = this.userid;
      }
      if (this._jurisdictionTaxData.payrollPayeeW4Form.stateW4) {
        this._jurisdictionTaxData.payrollPayeeW4Form.stateW4.id = this._jurisdictionTaxData.payrollPayeeW4Form.stateW4Id;
      } else {
        this._jurisdictionTaxData.payrollPayeeW4Form.stateW4Id = null;
      }
    } else {
      if (this._jurisdictionTaxData.payrollPayeeW4Form) {
        if (!this._jurisdictionTaxData.payrollPayeeW4Form.stateW4) {
          this._jurisdictionTaxData.payrollPayeeW4Form.stateW4Id = null;
        }
      }
    }

    this._jurisdictionTaxData.payrollPayeeW4Form.year = (new Date()).getFullYear();
    this._jurisdictionTaxData.payrollPayeeW4Form.payeeId = this.userid;
    // emit back to component
    this.onChangeTaxInfo.emit(this._jurisdictionTaxData);
  }

}
